// The console's Overview (A19U1), owned by hand: the greeting in the Console's ink header (it owns the header), the
// server's six figures and the failing jobs; any platform role reads it (the layout lets in only staff).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { ConsoleOverview } from '../../features/platform/ConsoleOverview'
import { consoleSummaryQuery } from '../../features/platform/queries'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/platform/')({
  staticData: { screenId: 'ConsoleHomeScreen', access: 'any platform role', ownHeader: true },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(consoleSummaryQuery()),
  component: ConsoleHomeScreen,
})

function ConsoleHomeScreen() {
  return (
    <main data-testid={ids.consoleHome.root}>
      <Part testId={ids.consoleHome.skeleton}>
        <ConsoleOverview />
      </Part>
    </main>
  )
}
